
































































import Vue from "vue";
import iwInputSelect from "@/shared/components/buildingBlocks/InputSelect.vue";
import iwDropdown from "@/shared/components/Dropdown.vue";
import { mapState } from "vuex";

export default Vue.extend({
    components: {
        iwInputSelect: iwInputSelect,
        iwDropdown: iwDropdown
    },

    props: {
        isMobile: {
            type:Boolean,
            required: false,
            default:false
        }
    },

    data: function() {
        return {
            triggerStyle: "filter--mobile" as string,
            selectedStatusType: "ALL" as string,
            internalStatusType: "ALL" as string
        };
    },

    computed: {
        ...mapState("MyClassifiedsModule", ["filterStatusType"]),

        options: function(): Array<Record<string, unknown>> {
            return [
                {
                    "label": this.$t("all_status"),
                    "value": "ALL",
                },
                {
                    "label": this.$t("status_draft"),
                    "value": "DRAFT"
                },
                {
                    "label": this.$t("status_active"),
                    "value": "ACTIVE"
                },
                {
                    "label": this.$t("status_inactive"),
                    "value": "INACTIVE",
                }
            ];
        },
        title: function() : string {
            if(this.filterStatusType !== "ALL") {
                return `status_${this.filterStatusType.toLowerCase()}`;
            } else {
                return "all_status";
            }
        }
    },

    mounted: function() {
        this.selectedStatusType = this.filterStatusType;
        this.internalStatusType = this.filterStatusType;

        if(this.isMobile) {
            this.triggerStyle = "filter--mobile";
        } else {
            this.triggerStyle = "filter filter--result-list";
        }
    },

    methods: {
        filterValue: function (status: string) {
            this.$store.commit("MyClassifiedsModule/setFilterStatusType", status);
            this.$emit("filter-value", status);
        },
        apply: function()  {
            this.$store.commit("MyClassifiedsModule/setFilterStatusType", this.internalStatusType);
            this.$emit("filter-value", this.internalStatusType);
            this.$emit("close-mobile-overlay");
        }
    }
});
